import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import { useInView } from 'react-intersection-observer';
import "./IntegrationView.css"
import useViewport from '../useViewport';

const IntegrationView = () => {

    const isMdOrLarger = useViewport();
    
    const handleChatButtonClick = () => {
        window.location.href = "/setup";
    };

    const [titleRef, inView1] = useInView({
        triggerOnce: true,
        threshold: 0.2,
    });

    return (
        <div className='integration-container background-secondary'>
            <Container maxWidth='xl'>
                <div className={`integration-title-container ${inView1 && isMdOrLarger ? 'fade-in' : ''}`} ref={titleRef}>
                    <h3 className='integration-pre-title foreground-highlight'>Get Started</h3>
                    <h1 className='integration-title text-title'>Effortless&nbsp;Integration</h1>
                    <h2 className='integration-subtitle text-description'>
                        <b>Blankwall</b> automagically generates AR experiences from your product listings.<br/>
                        No manuall per-product setup or asset linking required.
                    </h2>
                </div>

                <Grid sx={{ display: 'flex', justifyContent: 'space-evenly', padding: { xs: '0 1rem', md: '3rem 1rem'}, flexDirection: { xs: 'column', md: 'row' } }}>
                    <div style={{ flex: '1', maxWidth: { xs: '100%', md: '33%'}, textAlign: { xs: 'center', md: 'left' } }}>
                        <h1 className='integration-step-number text-title foreground-highlight'>01</h1>
                        <h1 className='integration-step-title text-heading'>
                            Install Blankwall from the Shopify App Store, or embedded our modular widget.
                        </h1>
                    </div>
                    <div style={{ flex: '1', maxWidth: { xs: '100%', md: '33%'}, textAlign: { xs: 'center', md: 'left' } }}>
                        <h1 className='integration-step-number text-title foreground-highlight'>02</h1>
                        <h1 className='integration-step-title text-heading'>
                            Add the Blankwall button to your product page.
                        </h1>
                    </div>
                    <div style={{ flex: '1', maxWidth: { xs: '100%', md: '33%'}, textAlign: { xs: 'center', md: 'left' } }}>
                        <h1 className='integration-step-number text-title foreground-highlight'>03</h1>
                        <h1 className='integration-step-title text-heading'>
                            Your entire catalog is immediately supported.
                        </h1>
                    </div>
                </Grid>

                <Grid sx={{ display: 'flex', justifyContent: 'center', paddingY: '3rem' }}>
                    <button className="hero-button hero-button-primary" onClick={handleChatButtonClick}>
                        See How It's Done
                    </button>
                </Grid>
            </Container>
        </div>
    );
}

export default IntegrationView;